import { GridBoxList } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { TLocationsLocation } from 'modules/locations/hooks/useLocations'

import Item from './Item'

const Locations = ({ items }: { items: TLocationsLocation[] }) => {
  const centered = items.length < 2

  return (
    <GridBoxList centered={centered}>
      {items.map((location: TLocationsLocation) => (
        <Item
          key={location.id}
          location={location}
          extra={location.main ? { 'data-intercom-target': 'workplaces-main-location' } : undefined}
        />
      ))}
    </GridBoxList>
  )
}

export default observer(Locations)
